var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHabitation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 600,
    zoomAndPan: "magnify",
    viewBox: "0 0 450 449.999984",
    height: 600,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "3cb8142dee"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 225 0 C 100.734375 0 0 100.734375 0 225 C 0 349.265625 100.734375 450 225 450 C 349.265625 450 450 349.265625 450 225 C 450 100.734375 349.265625 0 225 0 Z M 225 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1a305d1c8c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 450 0 L 450 450 L 0 450 Z M 0 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0f2c755238"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 225 0 C 100.734375 0 0 100.734375 0 225 C 0 349.265625 100.734375 450 225 450 C 349.265625 450 450 349.265625 450 225 C 450 100.734375 349.265625 0 225 0 Z M 225 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4599546bf8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 450,
    y: 0,
    height: 450
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "467669b121"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 93.015625 88.78125 L 357 88.78125 L 357 352.78125 L 93.015625 352.78125 Z M 93.015625 88.78125 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3cb8142dee)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4599546bf8)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1a305d1c8c)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0f2c755238)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -99,
    width: 648,
    fill: "#28a745",
    height: 647.999977,
    y: -98.999996,
    fillOpacity: 1
  }))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#467669b121)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 225 88.78125 L 356.980469 220.765625 L 315.738281 220.765625 L 225 130.027344 L 134.261719 220.765625 L 93.015625 220.765625 Z M 225 163.023438 L 142.511719 245.511719 L 142.511719 352.746094 L 192.003906 352.746094 L 192.003906 286.753906 L 257.996094 286.753906 L 257.996094 352.746094 L 307.488281 352.746094 L 307.488281 245.511719 Z M 225 163.023438 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHabitation);
export default __webpack_public_path__ + "static/media/icon_habitation.5a2bebf3d74adbcbd992d0c25c12200a.svg";
export { ForwardRef as ReactComponent };